import { useNavigate, useRouterState } from "@tanstack/react-router";
import { ARTICLES, compendiumTabs } from "@/platform/compendium";
import { isPlainNavClick } from "@/platform/lib/nav";

// The Compendium sub-nav tab strip: the Overview landing plus each Article in nav order, derived from the
// manifest. The Compendium layout owns it, so it renders under the shared header on every Compendium surface. The
// active tab is the current route by exact path, so Overview lights only on the bare /thecore
// landing, an Article tab only on its own page. Real <a href>s, enhanced to client navigation.
export function CompendiumTabs() {
  const navigate = useNavigate();
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  return (
    <nav className="compendium-tabs" aria-label="TheCore sections">
      {compendiumTabs(ARTICLES).map((tab) => {
        const active = pathname === tab.to;
        return (
          <a
            key={tab.to}
            href={tab.to}
            className={active ? "compendium-tab on" : "compendium-tab"}
            aria-current={active ? "page" : undefined}
            onClick={(e) => {
              if (isPlainNavClick(e)) {
                e.preventDefault();
                navigate({ to: tab.to } as Parameters<typeof navigate>[0]);
              }
            }}
          >
            {tab.label}
          </a>
        );
      })}
    </nav>
  );
}
